var map = {
	"./2H-coffee-break.jpg": 9138,
	"./AgileBeyondLogo.png": 92859,
	"./GOL-logo.png": 73085,
	"./Logi-Sys-new.png": 11741,
	"./PFC.jpg": 78002,
	"./PFC1.jpg": 63709,
	"./QUOTISS.png": 15669,
	"./QUOTISS1.png": 40680,
	"./schneider.png": 20948,
	"./schneider1.png": 64247,
	"./schneider2.png": 6140
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76639;